import React from 'react';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from 'components/common/modals';
import { getFullName } from '@utils';
import { IconButtonV2 } from 'components/common/ui';
import Link from 'next/link';
import styles from './selectedUser.style';

const SelectedUser = ({ user = {}, onClose }) => {
  const userSubscription = user?.subscriptions?.[0];
  const hasDriverStatus =
    !!userSubscription && typeof userSubscription.activeDriver === 'boolean';
  const isActiveDriver = userSubscription?.activeDriver === true;

  return (
    <>
      <Box sx={styles.title}> User</Box>
      <Box sx={styles.wrapper}>
        {hasDriverStatus && (
          <Tooltip
            title={isActiveDriver ? 'Active driver' : 'Inactive driver'}
            placement="top"
          >
            <Box
              sx={
                isActiveDriver
                  ? styles.activeDriverDot
                  : styles.inactiveDriverDot
              }
            />
          </Tooltip>
        )}
        <Box sx={styles.column}>
          <Box sx={styles.row}>
            <Box sx={styles.name}>{getFullName(user)}</Box>
            <Box>
              {user.id ? (
                <Link href={`/users/${user.id}`}>{user.internalId || '-'}</Link>
              ) : (
                <span>{user.internalId || user.id || '-'}</span>
              )}
            </Box>
          </Box>
          <Box sx={styles.row}>
            <Box>{user.email || '-'}</Box>
            <Box>{user.phoneNumber || '-'}</Box>
          </Box>
        </Box>
        {onClose && (
          <Box>
            <IconButtonV2 variant="text" color="error" onClick={onClose}>
              <CloseIcon />
            </IconButtonV2>
          </Box>
        )}
      </Box>
    </>
  );
};

export default SelectedUser;
